import { getCurrentHostname, isPublicAppHostname } from "./utils/publicApp";

const defaultBackendBase = "https://backend.buzzvibe.com";

const currentHostname = getCurrentHostname();

// Use same-origin API on BuzzVibe-owned hosts so Vercel rewrites handle backend routing.
const shouldUseSameOriginApi = isPublicAppHostname(currentHostname);

const defaultApiBase = shouldUseSameOriginApi
	? "/api/v2"
	: `${defaultBackendBase}/api/v2`;

const configuredServer = process.env.REACT_APP_SERVER_URL;
const configuredAdsServer = process.env.REACT_APP_ADS_SERVER_URL;
const configuredEcommerceServer = process.env.REACT_APP_ECOMMERCE_SERVER_URL;

export const server = shouldUseSameOriginApi
	? "/api/v2"
	: configuredServer || defaultApiBase;

export const adsServer = shouldUseSameOriginApi
	? "/api/v2"
	: configuredAdsServer || server;

export const ecommerceServer = shouldUseSameOriginApi
	? "/api/v2"
	: configuredEcommerceServer || server;

export const backend_url = process.env.REACT_APP_BACKEND_URL || defaultBackendBase;
